import { Trans, useTranslation } from "react-i18next";

export const tc = {
  sb: <span className="font-semibold" />,
  b: <span className="font-bold" />,
  i: <span className="italic" />,
  prolificSubmissionsLink: (
    <a
      href="https://app.prolific.com/submissions"
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold underline text-blue-500 dark:text-blue-400"
    />
  ),
  claudeLink: (
    <a
      href="https://claude.ai"
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold underline text-blue-500 dark:text-blue-400"
    />
  ),
  chatGPTLink: (
    <a
      href="https://chatgpt.com"
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold underline text-blue-500 dark:text-blue-400"
    />
  ),
  geminiLink: (
    <a
      href="https://takeout.google.com"
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold underline text-blue-500 dark:text-blue-400"
    />
  ),
} as const;

interface TProps extends Omit<React.ComponentProps<typeof Trans>, "components"> {}

export function T(props: TProps) {
  useTranslation();
  return <Trans {...props} components={tc} />;
}
